// extracted by mini-css-extract-plugin
export default {"wrapper":"default_wrapper__-D1KI","content":"default_content__fHo1z","icon":"default_icon__A-Y3R","header":"default_header__ZttvC","text":"default_text__Zsq6P"};